import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, Output } from '@angular/core';

import { EventModel, EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';

import { ScoreboardParticipantComponent } from './scoreboard-participant.component';

@Component({
    selector: 'ms-pair-game-participant',
    templateUrl: 'pair-game-participant.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, ParticipantImageComponent, ScoreboardParticipantComponent],
})
export class PairGameParticipantComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() participant: EventParticipant;
    @Input() sportId: number;
    @Input() redCardsCount: number;
    @Input() showLogoColor: boolean;
    @Input() isNewEDPScoreboard = false;
    @HostBinding('class') className = 'participant';
    @HostBinding('class.show-red-card') showRedCard = false;
    @Output() imageLoaded = new EventEmitter<boolean>();

    redCards: number[] = [];

    ngOnChanges(): void {
        this.showRedCard = this.redCardsCount > 0;
        this.redCards = new Array(this.redCardsCount);
    }
}
